import { GraphQLClient } from 'graphql-request';

let client: GraphQLClient | undefined;

const getGraphQLClient = (): GraphQLClient => {
  const GRAPHQL_API_URL = process.env.NEXT_PUBLIC_GRAPHQL_API_URL;
  const GRAPHQL_API_TOKEN = process.env.NEXT_PUBLIC_GRAPHQL_API_TOKEN;

  if (!GRAPHQL_API_URL) {
    throw new Error('Environment variable NEXT_PUBLIC_GRAPHQL_API_URL is not set.');
  }

  if (!GRAPHQL_API_TOKEN) {
    throw new Error('Environment variable NEXT_PUBLIC_GRAPHQL_API_TOKEN is not set.');
  }

  if (!client) {
    const uri = GRAPHQL_API_URL;

    client = new GraphQLClient(uri, {
      headers: {
        Authorization: `Bearer ${GRAPHQL_API_TOKEN}`
      }
    });
  }

  return client;
};

export default getGraphQLClient;
